import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getAccommodation, updateAccommodation } from "../api/accommodation.api";
import { AccomodationFormData } from "../types/accomodation.types";
import { toast } from "@/hooks/use-toast";
import { AxiosError } from "axios";
import { accommodationSchema } from "../schemas/accomodation.schema";

interface ErrorResponse {
  message: string;
  errors?: Record<string, string[]>;
}

interface MutationContext {
  onSuccess?: () => void;
  onError?: (error: AxiosError<ErrorResponse>) => void;
}

export const useAccommodationUpdate = (id?: string) => {
  const queryClient = useQueryClient();

  const { data: accommodation, isLoading, error } = useQuery({
    queryKey: ["accommodation", id],
    queryFn: async () => {
      if (!id) {
        return null;
      }
      const response = await getAccommodation(id);
      console.log('Datos recibidos del servidor:', response.data);
      // Aseguramos que los datos cumplan con el schema
      const validatedData = accommodationSchema.parse(response.data); // Cool
      return validatedData;
    },
    enabled: !!id, // Solo ejecutar la consulta si hay un ID
  });

  if (error) {
    console.error('Error en useQuery:', error);
  }

  //console.log('Valor retornado por el hook useAccommodationUpdate:', accommodation);

  const { mutate: updateAccommodationMutation } = useMutation({
    mutationFn: (data: AccomodationFormData) => {
      if (!id) {
        throw new Error('Se requiere un ID para actualizar el alojamiento');
      }

      console.log(data);
      return updateAccommodation(id, data);
    },
    onSuccess: (_, variables, context: MutationContext) => {
      queryClient.invalidateQueries({ queryKey: ["accommodation", id] });
      if (context?.onSuccess) {
        context.onSuccess();
      }
    },
    onError: (error: AxiosError<ErrorResponse>, variables, context: MutationContext) => {
      if (context?.onError) {
        context.onError(error);
      }
    },
  });

  return {
    accommodation,
    isLoading,
    updateAccommodation: updateAccommodationMutation,
  };
}; 